import React, { useCallback, useEffect } from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import WhiteboardController from '../../controllers/WhiteboardController';
import classNames from 'classnames';

interface DrawerPortalProps {
  drawerOpen?: boolean;
  children: React.ReactNode;
}

const DrawerPortal: React.FC<DrawerPortalProps> = ({
  children,
  drawerOpen = false,
}) => {
  const controller = useController(WhiteboardController);

  const closeDrawer = useCallback<(event: MouseEvent) => void>(
    event => {
      if (!(event.target instanceof HTMLElement)) return;
      if (
        event.target.closest(
          '.drawer-container, aha-menu-item, aha-menu-content, [data-tippy-root]'
        )
      )
        return;

      controller.actionCloseDrawer();
    },
    [controller]
  );

  useEffect(() => {
    window.addEventListener('mousedown', closeDrawer, true);

    return () => window.removeEventListener('mousedown', closeDrawer, true);
  }, [closeDrawer]);

  return (
    <div
      className={classNames('drawer fade drawer-container', {
        in: drawerOpen,
      })}
    >
      <div className='content-main'>{children}</div>
    </div>
  );
};

export default ApplicationView(DrawerPortal);
